import React from "react";
import { hero } from "../../mock/mock";

const RibbonText = () => {
  const items = hero.ribbon;
  const seq = [...items, ...items, ...items, ...items];
  return (
    <>
      {seq.map((t, i) => (
        <span key={`${t}-${i}`} className="inline-flex items-center">
          <span className="font-body font-semibold text-white text-sm md:text-base tracking-wide-sm uppercase px-5">
            {t}
          </span>
          <span className="text-white/80 text-xs">&bull;</span>
        </span>
      ))}
    </>
  );
};

const Ribbon = ({ position, fast }) => (
  <div
    className={`absolute z-20 ${position} -left-[10%] w-[120%] rotate-[-9deg] bg-[#C8102E] py-2.5 shadow-lg overflow-hidden`}
  >
    <div className={`marquee-track ${fast ? "marquee-fast" : ""}`}>
      <RibbonText />
    </div>
  </div>
);

const GiantWords = () => (
  <div className="absolute inset-0 flex items-center justify-between px-2 md:px-6 z-10 select-none">
    <h1 className="font-display text-white leading-none text-[19vw] md:text-[16vw] lg:text-[15vw] drop-shadow-[0_4px_20px_rgba(0,0,0,0.08)]">
      {hero.wordOne}
    </h1>
    <h1 className="font-display text-white leading-none text-[19vw] md:text-[16vw] lg:text-[15vw] drop-shadow-[0_4px_20px_rgba(0,0,0,0.08)]">
      {hero.wordTwo}
    </h1>
  </div>
);

const HeroModel = () => (
  <div className="absolute inset-x-0 bottom-0 z-20 flex justify-center items-end h-full pointer-events-none">
    <img
      src={hero.model}
      alt="Overdressed Couture model in black cut-out gown"
      className="h-[92%] md:h-[96%] w-auto object-contain object-bottom float-model rise-in"
      style={{ filter: "drop-shadow(0 20px 40px rgba(0,0,0,0.25))" }}
    />
  </div>
);

const LargeHero = () => {
  return (
    <section id="top" className="relative w-full overflow-hidden pt-[64px]">
      <div className="relative mx-3 md:mx-6 mt-2 rounded-[10px] overflow-hidden">
        <div className="relative h-[82vh] min-h-[560px] bg-gradient-to-br from-[#F9C3CD] via-[#F8BEC9] to-[#F6B7C4]">
          <p className="absolute top-6 left-1/2 -translate-x-1/2 z-30 font-body text-white text-[11px] md:text-sm font-semibold tracking-wide-lg uppercase text-center px-4">
            {hero.microTagline}
          </p>
          <GiantWords />
          <Ribbon position="top-[14%]" />
          <Ribbon position="bottom-[10%]" fast />
          <HeroModel />
        </div>
      </div>
    </section>
  );
};

export default LargeHero;
